import React, { useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import CaseTable from '../../../components/CaseTable';
import { getAllReportedFIsCases } from '../../../redux/api/cases';
import { getAllInstitutions } from '../../../redux/api/institution';
import { Dialog, DialogContent, DialogActions, Button, DialogTitle, IconButton } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const ReportedInstitutions = ({ user}) => {
    const [processing, setProcessing] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [records, setRecords] = useState([]);
    const [institutions, setInstitutions] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [selectedCase, setSelectedCase] = useState(null);
    const [open, setOpen] = useState(false);

    const init = async (start = 0, length = user.paginationSize) => {
        try {
            setProcessing(true);
            const res = await getAllReportedFIsCases({ start, length });
            const resp = await getAllInstitutions();
            setRecords(
                records?.length < length
                    ? res?.resultObject?.data || []
                    : records.concat(res?.resultObject?.data || [])
            );
            setInstitutions(resp?.resultObject || []);
            setPaginationData({
                start,
                length,
                total: res?.resultObject?.recordsTotal,
                totalFiltered: res?.resultObject?.recordsFiltered,
            });
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    const exportData = async () => {
        try {
            const resp = await getAllReportedFIsCases({}, true);
            enqueueSnackbar(
                resp?.message ||
                    'Your report is being processed, kindly check the reports page for progress'
            );
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const search = async (values, closeSearchModal) => {
        try {
            const res = await getAllReportedFIsCases(values);
            if (res?.statusCode == '000') {
                setRecords(res?.resultObject?.data || []);
                closeSearchModal();
                if (res?.resultObject?.data?.length == 0) {
                    enqueueSnackbar('No result found for search parameters', {
                        variant: 'error',
                    });
                }
            } else {
                enqueueSnackbar(res?.message || 'An error occurred', {
                    variant: 'info',
                });
            }
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    useEffect(() => {
        init();
    }, [user.paginationSize]);

    return (
        <PageContainer
            pageTitle="Reported Institutions"
            processing={processing}
        >
            <CaseTable
                additionalActions={(params) => (
                    <>
                        <IconButton
                            color="info"
                            title="Report details"
                            onClick={() => {
                                setSelectedCase(params);
                                setOpen(true);
                            }}
                        >
                            <InfoOutlined />
                        </IconButton>
                    </>
                )}
                customColumns={[
                    {
                        field: 'trackingReferenceNumber',
                        headerName: 'Tracking Reference No.',
                        width: 250,
                    },
                    {
                        field: 'rinstitution',
                        headerName: 'Reporting Institution',
                        width: 250,
                        valueGetter: (params) =>
                            params?.row?.bankToBankComplaint?.institutionFor?.name || institutions?.find(r => r?.institutionId == params?.row?.bankToBankComplaint?.fI_For)?.name || '',
                    },
                    {
                        field: 'institution',
                        headerName: 'Reported Institution',
                        width: 250,
                        valueGetter: (params) =>
                            params?.row?.bankToBankComplaint?.institutionAgainst?.name || institutions?.find(r => r?.institutionId == params?.row?.bankToBankComplaint?.fI_Against)?.name || '',
                    },
                    {
                        field: 'title',
                        headerName: 'Title',
                        width: 200,
                        valueGetter: (params) => params?.row?.bankToBankComplaint?.title || '',
                    },
                    {
                        field: 'subcategoryCode',
                        headerName: 'Subcategory Code',
                        width: 200,
                        valueGetter: (params) =>
                            params?.row?.bankToBankComplaint?.subcategoryCode || '',
                    },
                    { field: 'caseId', headerName: 'Case ID', width: 250,
                        renderCell: (params) =>
                            <span>{params?.row?.caseId || ''}</span>,
                    
                     },
                ]}
                addActionColumn
                cases={records}
                showAttachBtn={false}
                showConversationBtn={false}
                showPendingActionsBtn={false}
                showAssignBtn={false}
                showAssignFooterBtn={false}
                showCloseCaseBtn={false}
                showDeEscalateCaseBtn={false}
                showEscalateCaseBtn={false}
                showResolveCaseBtn={false}
                showReOpenFooterBtn={false}
                showReOpenCaseBtn={false}
                showReAssignFooterBtn={false}
                showReportedInstitutions={true}
                selectable={false}
                exportFunction={exportData}
                searchFunction={search}
                institutions={institutions}
                paginationData={paginationData}
            />

            <Dialog open={open} maxWidth="md">
                <DialogTitle>Reported Case Information</DialogTitle>
                <DialogContent>
                    <p>
                        <b>Title:</b> {selectedCase?.bankToBankComplaint?.title}
                    </p>
                    <p>
                        <b>Subcategory:</b> {selectedCase?.bankToBankComplaint?.subcategoryCode}
                    </p>
                    <p>
                        <b>Reporting Institution:</b>{' '}
                        {selectedCase?.bankToBankComplaint?.institutionFor?.name || institutions?.find(r => r?.institutionId == selectedCase?.bankToBankComplaint?.fI_For)?.name || ''}
                    </p>
                    <p>
                        <b>Reported Institution:</b>{' '}
                        {selectedCase?.bankToBankComplaint?.institutionAgainst?.name || institutions?.find(r => r?.institutionId == selectedCase?.bankToBankComplaint?.fI_Against)?.name || ''}
                    </p>
                    <p>
                        <b>Message:</b> {selectedCase?.bankToBankComplaint?.message}
                    </p>
                </DialogContent>
                <DialogActions className="pr-1 pb-1">
                    <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => {
                            setOpen(false);
                            setSelectedCase(null);
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </PageContainer>
    );
};

export default connect(({ user }) => ({ user }))(ReportedInstitutions);
